<template>
    <v-dialog persistent v-model="dialog" :width="($vuetify.breakpoint.mdAndUp)? '50%' : '95%'">
        <v-card>
            <v-card-title>{{$t('Select active website')}}</v-card-title>
            <v-card-text>
                <div class="row">
                    <div class="col-md-3" v-for="item in websites" @click="$store.dispatch('websites/setActive', item)" style="cursor: pointer">
                        <v-card class="w-100 d-flex align-center" height="200px">
                            <v-img v-if="item.logo" width="100%" height="180px" contain :src="getSrc(item.logo)"></v-img>
                            <div v-else style="width: 100%; height: 180px;"></div>
                        </v-card>
                        <div class="w-100 mt-2">{{item.name}}</div>
                        <div style="font-size: 12px" class="grey--text">{{item.link}}</div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    data:() => {
        return{

        }
    },
    computed:{
        dialog(){
            return false;
            // return this.$store.getters.selectWebsite;
        },
        websites(){
            return this.$store.getters.websites;
        }
    },
    mounted(){
        if(this.$store.getters.selectWebsite){
            this.$store.dispatch('websites/setActive', this.websites[this.websites.length - 1]);
        }

    }
}
</script>
